import React from "react";
import { ErrorMessage, useFormikContext } from "formik";
import FormControl from "@mui/material/FormControl";
import { styled } from "@mui/material/styles";
import TextField from "@mui/material/TextField";
import Tooltip from "@mui/material/Tooltip";
import { convertTextToTitleCase } from "../../CommonFuntion/SchemaValidation";
import { titleCase } from "../../CommonFuntion/SchemaValidation";
import { applyMaskOnBlur } from "../../CommonFuntion/applyMaskOnBlur";

const CssTextField = styled(TextField)({});

export function Txt(props) {
  const { name, label, tagName, validation, prefix } = props;

  const { setFieldValue, values } = useFormikContext();
  const id = `${tagName}-input`;

  const handleChange = (e) => {
    const { value } = e.target;
    setFieldValue([name], value);
    if (validation.characterCase) {
      switch (validation.characterCase) {
        case "U":
          setFieldValue([name], value.toUpperCase());
          break;
        case "L":
          setFieldValue([name], value.toLowerCase());
          break;
        case "C":
          setFieldValue([name], convertTextToTitleCase(value));
          break;
        default:
          setFieldValue([name], value);
          break;
      }
    }
  };

  const handleBlur = (e) => {
    if (!validation?.pictureMask) return;
    const { nextValue, applied } = applyMaskOnBlur(
      e.target.value,
      validation.pictureMask
    );
    if (applied) {
      setFieldValue([name], nextValue);
    }
  };

  return (
    <>
      <div className="flex-container">
        <div className="control-bottom-border">
          {label && (
            <label className="font-css" htmlFor={id}>
              {titleCase(label.replace("_", " "))}
              {validation?.mandatory && (
                <span className="mandatory-validation">{"*"}</span>
              )}
            </label>
          )}
        </div>

        <div className="control-bottom-border">
          <FormControl>
            <Tooltip
              title={
                validation.pictureMask
                  ? "Picture Mask:" + validation.pictureMask.replace(/"/g, "")
                  : ""
              }
            >
              <CssTextField
                id={id}
                inputProps={{
                  maxLength: validation?.pictureMask?.length
                    ? validation?.pictureMask?.replace(/"/g, "").length
                    : "",
                }}
                type="text"
                name={name}
                key={name}
                tagname={tagName}
                prefix={prefix}
                fullWidth
                placeholder=""
                style={{
                  fontSize: "12px",
                  width: "200px",
                }}
                onChange={handleChange}
                onBlur={handleBlur}
                variant="standard"
                value={values?.[name] || ""}
              />
            </Tooltip>
          </FormControl>

          <ErrorMessage
            name={name}
            render={(msg) => {
              return <div className="is-invalid">{msg}</div>;
            }}
          />
        </div>
      </div>
    </>
  );
}
